<template>
  <div
    v-if="brandStore.layout === 'brand-builder'"
    class="min-h-screen h-full bg-[linear-gradient(143.08deg,#F7FBFF_21.45%,#EEF7FF_78.55%)]"
  >
    <TsSection
      :append-class="twMerge('overflow-hidden mb-4', isMobile && 'px-0')"
    >
      <TsBreadcrumb :data="breadcrumbData" />
      <TsTitle
        animate
        :title="useCapitalize(brandStore.brandSlug)"
        append-class="before:bg-dewalt mt-4"
      />
    </TsSection>
    <TsSection>
      <TsRow append-class="m-0">
        <TsRow append-class="m-0">
          <TsTabsLinksSelection
            :tabs="tabs"
            :append-class="isMobile ? 'p-0 pb-4' : 'p-0 py-3 ml-0 mt-0'"
            bordered
          />
        </TsRow>
      </TsRow>
    </TsSection>
    <TsBrandDeals></TsBrandDeals>
  </div>
  <div v-else id="brands-deals" ref="tabContentReference">
    <TsBrandDeals></TsBrandDeals>
  </div>
</template>

<script setup>
import { twMerge } from "tailwind-merge";

const TsBreadcrumb = defineAsyncComponent(() => import('~/components/molecules/TsBreadcrumb.vue'));
const TsTabsLinksSelection = defineAsyncComponent(() => import('~/components/molecules/TsTabsLinksSelection.vue'));
const TsBrandDeals = defineAsyncComponent(() => import('~/components/organisms/TsBrandDeals.vue'));

const { isMobile } = useDevice();
const builderStore = useBuilderStore();
const brandStore = useBrandStore();
const route = useRoute();

await setActiveComponent();

definePageMeta({
  layout: "brand-plp",
});

async function setActiveComponent() {
  brandStore.brandSlug = route.params.brandName;
  let brand = null;

  if (builderStore.topBrands.length === 0) {
    const { data } = await useAsyncData("brand", () =>
      builderStore.fetchBrandBySlug(getBrandSlug(brandStore.brandSlug)), {
          dedupe: "cancel",
      }
    );

    if (data && data.value && data.value.data && data.value.data.topBrand) {
      brand = data.value.data.topBrand;
    }
  } else {
    brand = builderStore.topBrands.find(
      (item) =>
        item.title &&
        item.title.toLowerCase() === brandStore.brandSlug.toLowerCase()
    );
  }

  if (brand && brand.isTop && brand.redirectToBrandListing === false) {
    brandStore.layout = "brand-builder";
    brandStore.activeTab = "deals";
  } else {
    brandStore.layout = "brand-plp";
  }
}

const breadcrumbData = ref([
  { text: useTranslation('home','Thuis'), links: "/" },
  { text: useTranslation('brand','Merk'), link: getBrandSlug() },
  { text: useCapitalize(brandStore.brandSlug.replaceAll("-", " ")) },
]);

const tabs = [
  {
    label: useTranslation("about", "Over"),
    icon: "mingcute:home-3-line",
    link: getBrandSlug(brandStore.brandSlug),
  },
  {
    label: useTranslation("products", "Producten"),
    icon: "codicon:tools",
    link: getBrandSlug(brandStore.brandSlug, "products"),
  },
  {
    label: useTranslation("deals", "Aanbiedingen"),
    icon: "bxs:offer",
    link: getBrandSlug(brandStore.brandSlug, "deals"),
  },
];
</script>
